export default "__VITE_ASSET__BhqN4aCf__"